import { render, staticRenderFns } from "./AboutArtFairs.vue?vue&type=template&id=0346a11e&scoped=true&"
import script from "./AboutArtFairs.vue?vue&type=script&lang=ts&"
export * from "./AboutArtFairs.vue?vue&type=script&lang=ts&"
import style0 from "./AboutArtFairs.vue?vue&type=style&index=0&id=0346a11e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0346a11e",
  null
  
)

export default component.exports